import { IMarketplaceInventoryInput, IVendorInventoryUploadInput } from '@admin-panel/types';
import CrudApiClient from './crudapiclient';
import { GATEWAY_API_URL } from '@admin-panel/config/env';
import { MetaQuery } from '@refinedev/core';
import { axiosInstance } from './axios';

class InventoryApiClient extends CrudApiClient {
  constructor() {
    super(GATEWAY_API_URL + '/inventory');
  }

  // @ts-ignore
  async createMany(
    payload: Array<IVendorInventoryUploadInput>,
    meta: MetaQuery | undefined,
  ): Promise<any> {
    try {
      const invRows: Array<IMarketplaceInventoryInput> = payload.map(
        (inv: IVendorInventoryUploadInput) => {
          const baseData = {
            quantity: inv.warehouseInventory,
            vendorId: meta?.vendorId,
            facilityCode: meta?.unicomFacilityCode,
          };

          if (meta?.useVendorSkuCode) {
            return {
              ...baseData,
              vendorSkuCode: inv.skuCode,
            };
          } else {
            return {
              ...baseData,
              skuCode: inv.skuCode,
            };
          }
        },
      );

      const response = await axiosInstance.post(`${this.baseURL}/upload`, invRows);
      return this.transformList(response.data.data);
    } catch (error) {
      console.error(`Error uploading entities in bulk:`, error);
      throw error;
    }
  }
}

export default InventoryApiClient;
